document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/* ================= Utilitaire global : échappement HTML ================= */
function olympicRelicsEscapeHtml(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/* ================= Retour en haut (footer) ================= */
(function () {
  var btn = document.querySelector('[data-scroll-top]');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY > 600);
  });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* ================= Header sticky compact ================= */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ================= Menu mobile ================= */
(function () {
  var drawer = document.getElementById('mobile-menu-drawer');
  if (!drawer) return;

  var openBtns = document.querySelectorAll('[data-mobile-menu-open]');
  var closeEls = drawer.querySelectorAll('[data-mobile-menu-close]');
  var panel = drawer.querySelector('.mobile-menu-drawer__panel');
  var lastFocused = null;

  drawer.setAttribute('aria-hidden', 'true');
  openBtns.forEach(function (btn) {
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'mobile-menu-drawer');
  });

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-menu-open');
    openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    var closeBtn = drawer.querySelector('[data-mobile-menu-close].mobile-menu-drawer__close');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-menu-open');
    openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    if (lastFocused) lastFocused.focus();
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });
  closeEls.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Tab') return;
    if (drawer.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (!panel) return;
    var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  drawer.querySelectorAll('.header-nav__item.has-dropdown > .header-nav__link').forEach(function (link) {
    link.setAttribute('aria-expanded', 'false');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var item = link.closest('.header-nav__item');
      var isOpen = item.classList.toggle('is-open');
      link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
})();

/* ================= Hero slider ================= */
(function () {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;

  var slides = hero.querySelectorAll('[data-hero-slide]');
  var dots = hero.querySelectorAll('[data-hero-dot]');
  var prevBtn = hero.querySelector('[data-hero-prev]');
  var nextBtn = hero.querySelector('[data-hero-next]');
  if (slides.length < 2) return;

  var current = 0;
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoplaySeconds = prefersReducedMotion ? 0 : parseInt(hero.dataset.autoplay || '6', 10);
  var timer = null;

  function show(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  function restartAutoplay() {
    if (timer) clearInterval(timer);
    if (autoplaySeconds > 0) {
      timer = setInterval(function () { show(current + 1); }, autoplaySeconds * 1000);
    }
  }

  function pauseAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); restartAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); restartAutoplay(); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { show(i); restartAutoplay(); });
  });

  hero.addEventListener('mouseenter', pauseAutoplay);
  hero.addEventListener('mouseleave', restartAutoplay);
  hero.addEventListener('focusin', pauseAutoplay);
  hero.addEventListener('focusout', restartAutoplay);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { pauseAutoplay(); } else { restartAutoplay(); }
  });

  restartAutoplay();
})();

/* ================= Onglets produits en vedette ================= */
(function () {
  document.querySelectorAll('.featured-products__tabs').forEach(function (tabs) {
    var section = tabs.closest('.featured-products');
    var triggers = tabs.querySelectorAll('[data-tab-trigger]');
    var panels = section.querySelectorAll('[data-tab-panel]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        triggers.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        trigger.classList.add('is-active');
        trigger.setAttribute('aria-selected', 'true');
        var target = document.getElementById(trigger.dataset.tabTrigger);
        if (target) target.classList.add('is-active');
      });
    });
  });
})();

/* ================= Résultats de recherche : tri ================= */
(function () {
  var select = document.querySelector('[data-search-sort]');
  if (!select) return;
  select.addEventListener('change', function () {
    var qs = new URLSearchParams(window.location.search);
    qs.set('sort_by', select.value);
    window.location.search = qs.toString();
  });
})();

/* ================= Connexion : afficher le formulaire de récupération du mot de passe ================= */
(function () {
  var panel = document.querySelector('[data-recover-panel]');
  if (!panel) return;
  document.querySelectorAll('[data-recover-open]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      panel.hidden = false;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  document.querySelectorAll('[data-recover-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { panel.hidden = true; });
  });
  // Si le formulaire de récupération a été soumis (erreurs ou succès), l'afficher directement
  if (panel.querySelector('.account-auth__error, .account-auth__success')) panel.hidden = false;
})();

/* ================= Compte client : adresses (pays/région + panneaux) ================= */
(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-address-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('data-address-toggle'));
    if (panel) panel.hidden = !panel.hidden;
  });

  function populateProvinces(fieldsEl) {
    var countrySelect = fieldsEl.querySelector('[data-address-country-select]');
    var provinceSelect = fieldsEl.querySelector('[data-address-province-select]');
    if (!countrySelect || !provinceSelect) return;

    var selectedOption = countrySelect.options[countrySelect.selectedIndex];
    var provincesRaw = selectedOption ? selectedOption.getAttribute('data-provinces') : null;
    var provinces = [];
    try { provinces = provincesRaw ? JSON.parse(provincesRaw) : []; } catch (e) { provinces = []; }

    var savedProvince = fieldsEl.getAttribute('data-address-province') || '';

    if (!provinces.length) {
      provinceSelect.innerHTML = '';
      provinceSelect.closest('.form-field').style.display = 'none';
      return;
    }
    provinceSelect.closest('.form-field').style.display = '';
    var html = '';
    provinces.forEach(function (pair) {
      var value = pair[0], label = pair[1];
      html += '<option value="' + value + '"' + (value === savedProvince ? ' selected' : '') + '>' + label + '</option>';
    });
    provinceSelect.innerHTML = html;
  }

  function initAddressFields(fieldsEl) {
    var countrySelect = fieldsEl.querySelector('[data-address-country-select]');
    if (!countrySelect) return;
    var savedCountry = fieldsEl.getAttribute('data-address-country');
    if (savedCountry) {
      Array.prototype.forEach.call(countrySelect.options, function (opt) {
        if (opt.textContent.trim() === savedCountry || opt.value === savedCountry) opt.selected = true;
      });
    }
    populateProvinces(fieldsEl);
    countrySelect.addEventListener('change', function () { populateProvinces(fieldsEl); });
  }

  document.querySelectorAll('[data-address-fields]').forEach(initAddressFields);
})();
(function () {
  var STORAGE_KEY = 'olympicRelicsWishlist';
  var drawer = document.getElementById('wishlist-drawer');

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function updateCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = count; });
  }

  function syncButtons(root) {
    var list = getWishlist();
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      var active = id && list.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toggle(id) {
    var list = getWishlist();
    var index = list.indexOf(id);
    if (index === -1) { list.push(id); } else { list.splice(index, 1); }
    setWishlist(list);
    syncButtons(document);
    updateCount();
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') renderWishlistDrawer();
    return index === -1; // true = ajouté, false = retiré
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-wishlist-id');
    if (!id) return;
    e.preventDefault();
    toggle(id);
  });

  syncButtons(document);
  updateCount();

  // Resynchronise les boutons favoris après un rendu AJAX (filtres collection, recherche...)
  var watchTargets = ['MainCollectionSection'];
  watchTargets.forEach(function (elId) {
    var el = document.getElementById(elId);
    if (!el || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () { syncButtons(el); }).observe(el, { childList: true, subtree: true });
  });

  /* ---------- Drawer favoris ---------- */
  function openWishlistDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    renderWishlistDrawer();
  }
  function closeWishlistDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  document.querySelectorAll('[data-wishlist-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      openWishlistDrawer();
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-close]')) closeWishlistDrawer();
    if (e.target.closest('[data-wishlist-remove]')) {
      var item = e.target.closest('[data-wishlist-item]');
      if (item) toggle(item.getAttribute('data-wishlist-id'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeWishlistDrawer();
  });

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function renderWishlistDrawer() {
    if (!drawer) return;
    var body = drawer.querySelector('[data-wishlist-drawer-body]');
    var countEl = drawer.querySelector('[data-wishlist-drawer-count]');
    var list = getWishlist();
    if (countEl) countEl.textContent = '(' + list.length + ')';

    if (!body) return;
    if (list.length === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Vous n\'avez encore ajouté aucune pièce à vos favoris.</p><a href="/collections/all" class="btn btn--outline">Découvrir la collection</a></div>';
      return;
    }

    body.innerHTML = '<p class="search-drawer__hint">Chargement de vos favoris…</p>';

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = '<div class="cart-drawer__items">';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') + '" alt="" width="78" height="78" loading="lazy">' : '';
        var variant = p.variants && p.variants[0];
        var price = variant ? variant.price : p.price;
        html += '' +
          '<div class="cart-item" data-wishlist-item data-wishlist-id="' + list[i] + '">' +
          '  <a href="' + p.url + '" class="cart-item__media">' + img + '</a>' +
          '  <div class="cart-item__info">' +
          '    <a href="' + p.url + '" class="cart-item__title">' + olympicRelicsEscapeHtml(p.title) + '</a>' +
          '    <span class="cart-item__price-mobile">' + formatMoney(price) + '</span>' +
          '    <div class="cart-item__row">' +
          '      <a href="' + p.url + '" class="btn btn--outline product-card__quick-add" style="padding:8px 14px;font-size:10.5px;">Voir la pièce</a>' +
          '      <button type="button" class="cart-item__remove" data-wishlist-remove aria-label="Retirer des favoris">' + iconTrashSvg() + '</button>' +
          '    </div>' +
          '  </div>' +
          '  <div class="cart-item__price"><span>' + formatMoney(price) + '</span></div>' +
          '</div>';
      });
      html += '</div>';
      body.innerHTML = html;
    });
  }

  function iconTrashSvg() {
    return '<svg class="icon icon-trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>';
  }
})();

/* ================= Sélecteurs de quantité (produit + panier) ================= */
(function () {
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.quantity-selector__btn--minus');
    var plus = e.target.closest('.quantity-selector__btn--plus');
    if (!minus && !plus) return;

    var wrapper = e.target.closest('[data-quantity-selector]');
    var input = wrapper.querySelector('.quantity-selector__input');
    var min = parseInt(input.min || '0', 10);
    var max = input.max !== '' ? parseInt(input.max, 10) : null;
    var value = parseInt(input.value || '1', 10);

    if (plus) value = (max !== null) ? Math.min(max, value + 1) : value + 1;
    if (minus) value = Math.max(min, value - 1);

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* ================= Panier AJAX + drawer ================= */
(function () {
  var drawer = document.getElementById('cart-drawer');

  function openCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return; // pas de JS: laisser le lien /cart natif
      e.preventDefault();
      refreshCartDrawer(openCartDrawer);
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function refreshCartDrawer(after) {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (typeof after === 'function') after();
      })
      .catch(function () { if (typeof after === 'function') after(); });
  }

  function renderCartDrawer(cart) {
    if (!drawer) return;
    setCartCount(cart.item_count);
    var body = drawer.querySelector('[data-cart-drawer-body]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty" data-cart-empty><p>Votre panier est actuellement vide.</p><a href="/collections/all" class="btn btn--outline">Découvrir la collection</a></div>';
      if (footer) footer.setAttribute('hidden', 'hidden');
      return;
    }

    if (footer) footer.removeAttribute('hidden');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var html = '<div class="cart-drawer__items" data-cart-items>';
    cart.items.forEach(function (item, i) {
      html += buildCartItemHtml(item, i + 1);
    });
    html += '</div>';
    body.innerHTML = html;
  }

  function buildCartItemHtml(item, index) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') + '" alt="" width="90" height="90" loading="lazy">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="cart-item__variant">' + olympicRelicsEscapeHtml(item.variant_title) + '</span>' : '';
    var comparePrice = item.original_price !== item.final_price
      ? '<span class="cart-item__price-compare">' + formatMoney(item.original_price) + '</span>' : '';

    return '' +
      '<div class="cart-item" data-cart-item data-line="' + index + '" data-key="' + item.key + '">' +
      '  <a href="' + item.url + '" class="cart-item__media">' + img + '</a>' +
      '  <div class="cart-item__info">' +
      '    <a href="' + item.url + '" class="cart-item__title">' + olympicRelicsEscapeHtml(item.product_title) + '</a>' +
      variant +
      '    <span class="cart-item__price-mobile">' + formatMoney(item.final_price) + '</span>' +
      '    <div class="cart-item__row">' +
      '      <div class="quantity-selector" data-quantity-selector data-cart-line-qty>' +
      '        <button type="button" class="quantity-selector__btn quantity-selector__btn--minus" aria-label="Diminuer la quantité">−</button>' +
      '        <input type="number" class="quantity-selector__input" min="0" value="' + item.quantity + '" inputmode="numeric" aria-label="Quantité">' +
      '        <button type="button" class="quantity-selector__btn quantity-selector__btn--plus" aria-label="Augmenter la quantité">+</button>' +
      '      </div>' +
      '      <button type="button" class="cart-item__remove" data-cart-remove aria-label="Retirer l\'article">' + iconTrashSvg() + '</button>' +
      '    </div>' +
      '  </div>' +
      '  <div class="cart-item__price">' + comparePrice + '<span>' + formatMoney(item.final_price) + '</span></div>' +
      '</div>';
  }

  function iconTrashSvg() {
    return '<svg class="icon icon-trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>';
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  // Ajout au panier (formulaires produit) en AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);

    if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.disabled = true; }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        openCartDrawer();
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; }
      });
  });

  // Changement de quantité / suppression dans le drawer et la page panier
  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-line-qty] .quantity-selector__input, .cart-item .quantity-selector__input');
    if (!qtyInput) return;
    var lineEl = e.target.closest('[data-cart-item]');
    if (!lineEl) return;
    var key = lineEl.dataset.key || lineEl.dataset.line;
    changeLine(key, parseInt(qtyInput.value, 10)).then(function (cart) {
      if (drawer) renderCartDrawer(cart);
      if (document.querySelector('[data-cart-page]')) window.location.reload();
    });
  });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    var lineEl = removeBtn.closest('[data-cart-item]');
    if (!lineEl) return;
    var key = lineEl.dataset.key || lineEl.dataset.line;
    changeLine(key, 0).then(function (cart) {
      if (drawer) renderCartDrawer(cart);
      if (document.querySelector('[data-cart-page]')) window.location.reload();
    });
  });

  // Code promo : utilise la fonctionnalité native de remise Shopify (/discount/CODE),
  // appliquée au panier puis redirection vers le checkout réel.
  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest('[data-promo-code-apply]');
    if (!applyBtn) return;
    var wrap = applyBtn.closest('[data-promo-code-form]');
    var input = wrap ? wrap.querySelector('input[name="discount"]') : null;
    var code = input ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    applyBtn.disabled = true;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });
})();

/* ================= Recherche prédictive ================= */
(function () {
  var searchDrawer = document.getElementById('search-drawer');

  function openSearchDrawer() {
    if (!searchDrawer) return;
    searchDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var input = searchDrawer.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearchDrawer() {
    if (!searchDrawer) return;
    searchDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  document.querySelectorAll('[data-search-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!searchDrawer) return;
      e.preventDefault();
      openSearchDrawer();
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-close]')) closeSearchDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSearchDrawer();
    document.querySelectorAll('.header-search__results:not([hidden])').forEach(function (box) { box.setAttribute('hidden', ''); });
  });

  var timer = null;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-search] input[type="search"]');
    if (!input) return;
    var form = input.closest('[data-predictive-search]');
    var resultsBox = form.parentElement.querySelector('[data-predictive-search-results]') || document.querySelector('[data-predictive-search-results]');
    var query = input.value.trim();

    clearTimeout(timer);
    if (query.length < 2) {
      if (resultsBox) {
        resultsBox.innerHTML = '<p class="search-drawer__hint">Commencez à taper pour découvrir médailles, monnaies, timbres et objets historiques.</p>';
        if (resultsBox.classList.contains('header-search__results')) resultsBox.setAttribute('hidden', '');
      }
      return;
    }

    timer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          renderPredictiveResults(resultsBox, data, query);
        })
        .catch(function () {});
    }, 250);
  });

  // Ouverture/fermeture du panneau de résultats de recherche header (desktop)
  document.addEventListener('focusin', function (e) {
    var input = e.target.closest('[data-predictive-search] input[type="search"]');
    if (!input) return;
    var form = input.closest('[data-predictive-search]');
    var resultsBox = form.parentElement.querySelector('[data-predictive-search-results]');
    if (resultsBox && resultsBox.innerHTML.trim() !== '') resultsBox.removeAttribute('hidden');
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.header-search__results:not([hidden])').forEach(function (box) {
      if (!box.closest('.header-search').contains(e.target)) box.setAttribute('hidden', '');
    });
  });

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderPredictiveResults(box, data, query) {
    if (!box) return;
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var safeQuery = escapeHtml(query);

    if (products.length === 0) {
      box.innerHTML = '<p class="search-drawer__empty">Aucun résultat pour « ' + safeQuery + ' ». <a href="/search?q=' + encodeURIComponent(query) + '">Voir tous les résultats</a></p>';
    } else {
      var html = '<ul class="predictive-search__list">';
      products.forEach(function (p) {
        html += '' +
          '<li class="predictive-search__item">' +
          '  <a href="' + p.url + '">' +
          '    <span class="predictive-search__media">' + (p.image ? '<img src="' + p.image + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
          '    <span class="predictive-search__info"><span class="predictive-search__title">' + escapeHtml(p.title) + '</span><span class="predictive-search__price">' + escapeHtml(p.price) + '</span></span>' +
          '  </a>' +
          '</li>';
      });
      html += '</ul><a class="predictive-search__view-all" href="/search?q=' + encodeURIComponent(query) + '">Voir tous les résultats →</a>';
      box.innerHTML = html;
    }
    box.removeAttribute('hidden');
  }
})();

/* ================= Fiche produit : galerie premium (navigation, zoom, lightbox, swipe) ================= */
(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    var mainImg = gallery.querySelector('[data-gallery-main-img]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var counterEl = gallery.querySelector('[data-gallery-current]');
    var current = 0;

    var slides = thumbs.length ? thumbs.map(function (t) {
      return { full: t.dataset.fullSrc, medium: t.dataset.mediumSrc, alt: t.dataset.alt };
    }) : (mainImg ? [{ full: mainImg.src, medium: mainImg.src, alt: mainImg.alt }] : []);

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      var slide = slides[current];
      if (mainImg && slide) {
        mainImg.src = slide.medium || slide.full;
        mainImg.srcset = '';
        if (slide.alt) mainImg.alt = slide.alt;
      }
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
      if (counterEl) counterEl.textContent = current + 1;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Swipe tactile sur l'image principale */
    if (mainWrap) {
      var touchStartX = null;
      mainWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 40) goTo(deltaX < 0 ? current + 1 : current - 1);
        touchStartX = null;
      }, { passive: true });
    }

    /* Zoom loupe (desktop, au survol) */
    if (gallery.hasAttribute('data-zoom-enabled') && mainWrap && mainImg && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      mainWrap.addEventListener('mousemove', function (e) {
        var rect = mainWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      mainWrap.addEventListener('mouseenter', function () { mainImg.classList.add('is-zoomed'); });
      mainWrap.addEventListener('mouseleave', function () { mainImg.classList.remove('is-zoomed'); mainImg.style.transformOrigin = ''; });
    }

    /* Ouverture de la visionneuse plein écran (lightbox) */
    var lightbox = document.querySelector('[data-lightbox]');
    if (mainWrap && lightbox && slides.length) {
      var lbImg = lightbox.querySelector('[data-lightbox-img]');
      var lbCurrent = lightbox.querySelector('[data-lightbox-current]');
      var lbTotal = lightbox.querySelector('[data-lightbox-total]');
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      var lbClose = lightbox.querySelector('[data-lightbox-close]');
      var lastFocused = null;

      function renderLightbox() {
        var slide = slides[current];
        if (!slide) return;
        lbImg.src = slide.full;
        lbImg.alt = slide.alt || '';
        if (lbCurrent) lbCurrent.textContent = current + 1;
        if (lbTotal) lbTotal.textContent = slides.length;
      }
      function openLightbox() {
        lastFocused = document.activeElement;
        renderLightbox();
        lightbox.hidden = false;
        document.body.classList.add('lightbox-open');
        if (lbClose) lbClose.focus();
      }
      function closeLightbox() {
        lightbox.hidden = true;
        document.body.classList.remove('lightbox-open');
        if (lastFocused) lastFocused.focus();
      }

      mainWrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) return;
        openLightbox();
      });
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { goTo(current - 1); renderLightbox(); });
      if (lbNext) lbNext.addEventListener('click', function () { goTo(current + 1); renderLightbox(); });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') { goTo(current - 1); renderLightbox(); }
        if (e.key === 'ArrowRight') { goTo(current + 1); renderLightbox(); }
      });

      var lbTouchStartX = null;
      lightbox.addEventListener('touchstart', function (e) { lbTouchStartX = e.changedTouches[0].clientX; }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        if (lbTouchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - lbTouchStartX;
        if (Math.abs(deltaX) > 40) { goTo(deltaX < 0 ? current + 1 : current - 1); renderLightbox(); }
        lbTouchStartX = null;
      }, { passive: true });
    }

    goTo(0);
  });

  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-accordion-item]');
      var isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('[data-accordion-item]').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('[data-accordion-trigger]').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

/* ================= Fiche produit : variantes dynamiques (prix, disponibilité, image) ================= */
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  var select = form.querySelector('[data-product-variant-select]');
  if (!select) return;

  var variantsScript = document.querySelector('[data-product-variants-json]');
  if (!variantsScript) return;
  var variants;
  try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

  var idInput = form.querySelector('[data-product-variant-id]');
  var priceWrap = document.querySelector('[data-product-price]');
  var priceCurrent = document.querySelector('[data-price-current]');
  var priceCompare = document.querySelector('[data-price-compare]');
  var availabilityEl = document.querySelector('[data-product-availability]');
  var addBtn = document.querySelector('[data-product-add-btn]');
  var addBtnLabel = document.querySelector('[data-add-btn-label]');
  var gallery = document.querySelector('[data-product-gallery]');
  var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
  var lowStockThreshold = parseInt((availabilityEl && availabilityEl.dataset.lowStock) || '3', 10);

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function updateForVariant(variant) {
    if (!variant) return;
    if (idInput) idInput.value = variant.id;

    if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
    if (priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoney(variant.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }

    if (availabilityEl) {
      availabilityEl.classList.remove('is-available', 'is-sold-out', 'is-low-stock');
      if (!variant.available) {
        availabilityEl.textContent = 'Actuellement indisponible';
        availabilityEl.classList.add('is-sold-out');
      } else if (variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue' && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold) {
        availabilityEl.textContent = 'Stock limité — ' + variant.inventory_quantity + ' exemplaire(s) restant(s)';
        availabilityEl.classList.add('is-low-stock');
      } else {
        availabilityEl.textContent = 'En stock — expédition sous 48h';
        availabilityEl.classList.add('is-available');
      }
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addBtnLabel) addBtnLabel.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
    }

    var qtyInput = form.querySelector('#ProductQty');
    if (qtyInput) {
      if (variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue') {
        var maxQty = Math.max(0, variant.inventory_quantity);
        qtyInput.max = maxQty;
        if (parseInt(qtyInput.value, 10) > maxQty) qtyInput.value = Math.max(1, maxQty);
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    if (variant.featured_image && thumbs.length) {
      var match = thumbs.filter(function (t) { return String(t.dataset.mediaId) === String(variant.featured_image.id); })[0];
      if (match) match.click();
    }
  }

  select.addEventListener('change', function () {
    var variant = variants.filter(function (v) { return String(v.id) === select.value; })[0];
    updateForVariant(variant);
  });
})();

/* ================= Fiche produit : partage (menu + copier le lien) ================= */
(function () {
  document.querySelectorAll('[data-share-menu]').forEach(function (menu) {
    var toggle = menu.querySelector('[data-share-toggle]');
    var panel = menu.querySelector('[data-share-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target)) { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    });

    var copyBtn = panel.querySelector('[data-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          var original = copyBtn.getAttribute('aria-label');
          copyBtn.setAttribute('aria-label', 'Lien copié !');
          setTimeout(function () { copyBtn.setAttribute('aria-label', original); }, 2000);
        });
      });
    }
  });
})();

/* ================= Fiche produit : récemment consultés (localStorage) ================= */
(function () {
  var STORAGE_KEY = 'olympic-relics:recently-viewed';
  var MAX_ITEMS = 8;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function writeStore(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
  }

  var trackingScript = document.querySelector('[data-product-tracking-json]');
  if (trackingScript) {
    var current;
    try { current = JSON.parse(trackingScript.textContent); } catch (e) { current = null; }
    if (current && current.id) {
      var items = readStore().filter(function (item) { return item.id !== current.id; });
      items.unshift(current);
      writeStore(items.slice(0, MAX_ITEMS));
    }
  }

  var container = document.querySelector('[data-recently-viewed]');
  var grid = document.querySelector('[data-recently-viewed-grid]');
  if (!container || !grid) return;

  var currentId = trackingScript ? (function () {
    try { return JSON.parse(trackingScript.textContent).id; } catch (e) { return null; }
  })() : null;

  var display = readStore().filter(function (item) { return item.id !== currentId; }).slice(0, 5);
  if (!display.length) return;

  var html = '';
  display.forEach(function (item) {
    html += '' +
      '<article class="product-card product-card--compact">' +
      '  <div class="product-card__media">' +
      '    <a href="' + item.url + '" class="product-card__media-link">' +
      (item.image ? '<img class="product-card__media-img product-card__media-img--primary" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="500" height="500" loading="lazy">' : '') +
      '    </a>' +
      '  </div>' +
      '  <div class="product-card__info">' +
      '    <h3 class="product-card__title"><a href="' + item.url + '">' + escapeHtml(item.title) + '</a></h3>' +
      '    <div class="product-card__price"><span class="product-card__price-current">' + formatMoney(item.price) + '</span></div>' +
      '  </div>' +
      '</article>';
  });
  grid.innerHTML = html;
  container.hidden = false;
})();

/* ================= Pièce du moment (navigation) ================= */
(function () {
  document.querySelectorAll('[data-piece-of-moment]').forEach(function (block) {
    var slides = block.querySelectorAll('[data-piece-slide]');
    var prevBtn = block.querySelector('[data-piece-prev]');
    var nextBtn = block.querySelector('[data-piece-next]');
    var counter = block.querySelector('[data-piece-current]');
    if (slides.length < 2) return;

    var current = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (counter) counter.textContent = pad(current + 1);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
  });
})();

/* ================= Défilement horizontal (jeux, timeline, galerie, carousel) ================= */
(function () {
  document.querySelectorAll('[data-scroll-prev], [data-scroll-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('section');
      var scroller = section ? section.querySelector('[data-scroller]') : null;
      if (!scroller) return;
      var amount = Math.min(scroller.clientWidth * 0.8, 480);
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollBy({ left: btn.hasAttribute('data-scroll-prev') ? -amount : amount, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });
})();
